import { Component } from '@angular/core';

@Component({
  selector: 'broker-check-filled-svg',
  templateUrl: './check-filled-svg.component.svg'
})
export class CheckFilledSvgComponent {}
